import React, { useEffect, useRef, useState } from "react";
import { Flex } from "@100mslive/roomkit-react";
import SEO from "../Common/SEO";

const CompanyCustomModule = props => {
  const { module, orgName } = props;
  const iframeRef = useRef(null);
  const containerRef = useRef(null);
  const [containerHeight, setContainerHeight] = useState("auto");

  useEffect(() => {
    const updateHeight = () => {
      if (containerRef.current) {
        const topOffset = containerRef.current.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        const calculatedHeight = windowHeight - topOffset - 16;
        setContainerHeight(calculatedHeight);
      }
    };

    updateHeight();
    window.addEventListener("resize", updateHeight); // Recalculate on resize

    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);

  return (
    <React.Fragment>
      <SEO title={`${orgName || "Profile"} | ${module?.name}`} />
      <Flex
        className="event-page-company-module"
        ref={containerRef}
        style={{ height: containerHeight }}
      >
        {module?.contentUrl ? (
          <iframe
            ref={iframeRef}
            className="event-page-company-module-content"
            title=" "
            src={`${module?.contentUrl}?t=${new Date()}`}
          ></iframe>
        ) : (
          <div>There are no content</div>
        )}
      </Flex>
    </React.Fragment>
  );
};

export default CompanyCustomModule;
